import Vue from 'vue'
import { BootstrapVue, BToast } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
//Vue.use(BToast)

Vue.component('b-toast', BToast)